import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers-index";
import { Hub } from "aws-amplify/utils";
import { EVENTS, handleAmplifyConfigured, handleParsingCallBackUrl, handleSignedInEvent, handleSignInEvent, handleSignInFailure, handleSignOutEvent } from "./util/hub";
import { authorizationApi } from "./services/authorization/api";
import { graphqlApi } from './services/graphql/api';
import { setRowSelection } from './services/graphql/slices/manage-applications-slice';
import { alertMiddleware } from "./services/graphql/alertMiddleware";
import { jobMiddleware } from "./services/graphql/jobMiddleware";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [setRowSelection.type],
    }
  }).concat(
    graphqlApi.middleware,
    authorizationApi.middleware,
    alertMiddleware,
    jobMiddleware,
    ),
});


Hub.listen("auth", async (data) => {
  const state = store.getState()
  const event = data?.payload?.event
  const { authentication } = state ?? {}

  switch (event) {
    case EVENTS.signIn:
    case EVENTS.signInWithRedirect:
      return handleSignInEvent({
        data,
        authentication,
        store
      })
      case EVENTS.signedIn:
        return await handleSignedInEvent({
          data,
          authentication,
          store,
          state
        })
    case EVENTS.signOut:
      return handleSignOutEvent({
        authentication,
        store
      })
    case EVENTS.configured:
      return handleAmplifyConfigured({
        data,
        authentication,
        store
      })
    case EVENTS.parsingCallbackUrl:
      return handleParsingCallBackUrl({
        store
      })
    case EVENTS.customState_failure:
    case EVENTS.cognitoHostedUI_failure:
    case EVENTS.signIn_failure:
        return handleSignInFailure({
          store
        })
    default: 
      return
  }
})
  
export { store };
